import { Replicator } from 'src/containers/Replicator';
import { PageGuard } from 'src/pages/PageGuard';
import { PAGES_CONFIG } from '../config';

export const ReplicatorPage = () => (
  <PageGuard hasAccess={PAGES_CONFIG.replicator.hasAccess}>
    <Replicator />
  </PageGuard>
);
